module.exports = __webpack_public_path__ + "static/img/91BM-048-BensonGuo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-048-BensonGuo.jpg
// module id = 9bjc
// module chunks = 0